export default {
  isLoading: true,
  orderQuoteFinancials: [],
  accountOrderQuoteFinancials: [],
  orderQuoteFinancialsSummation: [],
};
